<template>
  <r-form-text-field
      :data-testid='dataTestid'
      ref="field"
      @update:error="hasError = $event"
      :error-messages="errorMessagesComputed"
      :loading="loading || loadingInternal"
      :label="label"
      :disabled="disabled"
      v-model="editedValue"
      @input="isEdited=true"
      @keydown="keydown()"
      @keyup.esc="revertField()"
      @keyup.enter="saveField()"
      v-bind="$attrs"
      v-on="$listeners">
    <template slot="append" v-if="editedValue != initialValue">
      <div>
        <v-btn data-testid="changed-field-save" icon small color="primary" @click="saveField()" :disabled="hasError">
          <v-icon>done</v-icon>
        </v-btn>
        <v-btn data-testid="changed-field-revert" v-if="!hideRevert" icon small color="primary" @click="revertField()">
          <v-icon>undo</v-icon>
        </v-btn>
      </div>
    </template>
  </r-form-text-field>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    initialValue: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    hideRevert: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: String | Array,
      default: () => {
        return [];
      }
    },
    dataTestid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      editedValue: this.initialValue,
      errorMessageInternal: [],
      hasError: false,
      loadingInternal: false,
      isEdited: false,
    }
  },
  computed: {
    errorMessagesComputed() {
      var msgs = [].concat(this.errorMessageInternal);
      if (Array.isArray(this.errorMessages)) {
        msgs = msgs.concat(this.errorMessages);
      }
      else if (typeof this.errorMessages === 'string') {
        msgs.push(this.errorMessages);
      }
      return msgs;
    }
  },
  methods: {
    revertField() {
      this.editedValue = this.initialValue;
      this.errorMessageInternal = [];
      this.$emit('revertField', {
        source: this,
      });
    },
    saveField() {
      if (this.hasError) return;
      this.$emit('saveField', {
        source: this,
        newValue: this.editedValue
      });
    },
    setError(msg) {
      if (msg == null) {
        this.errorMessageInternal = [];
      }
      else {
        this.errorMessageInternal = [msg];
      }
    },
    setEditedValue(new_value) {
      this.editedValue = new_value;
    },
    setLoading(loading) {
      this.loadingInternal = loading;
    },
    keydown(field) {
      this.errorMessageInternal = [];
    },
    focus() {
      this.$refs.field.focus();
    }
  },
  watch: {
    initialValue(new_initial) {
      if (!this.isEdited) {
        this.editedValue = new_initial;
      }
    },
    editedValue(new_edited_value) {
      this.$emit('editedValue', new_edited_value);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/ui/InlineEditField.vue